/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


controls = document.querySelector('.tabs');
tabs = document.querySelectorAll('.tab');
tabContents = document.querySelectorAll('.tab-content');
dotsContainer = document.querySelector('.indicators');
dots = document.querySelectorAll('.indicator');
 
tabs.forEach(function(tab){
  tab.addEventListener('click', function() {

    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);
    
    if (this.classList.contains('active')) {
    	null;
    } else {
    	controls.classList.toggle('invert');
      	dotsContainer.classList.toggle('invert');
      
        dots.forEach(function(dot) {
      		dot.classList.toggle('active');
    	});
    }

    tabContents.forEach(function(content) {
      content.classList.remove('active');
    });

    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});





                                                                    
